
import Vue from 'vue';
import IImage from '@frontend/types/base/IImage';
import { pushToDataLayer } from '@frontend/utils/TrackingUtil';
import { Prop } from 'vue-property-decorator';

export default abstract class AbstractRaffle<S extends Record<string, any>> extends Vue {
	@Prop(Object)
	public readonly steps!: S;

	@Prop({ type: String, default: null })
	public readonly primaryBackgroundColor?: string;

	@Prop(Object)
	public readonly image!: IImage;

	@Prop(Object)
	public readonly bearImage?: IImage;

	@Prop(Object)
	protected readonly backgroundImage?: IImage;

	@Prop(Object)
	protected readonly backgroundImagePortrait?: IImage;

	@Prop(String)
	public readonly raffleId?: string;

	@Prop(String)
	public readonly trackingId?: string;

	public activeStep: keyof S = 'intro';

	protected gotoStep(stepId: keyof S) {
		this.addHeightOnWrapper();
		this.activeStep = stepId;
		this.alignModuleToTop();
	}

	/**
	 * Use the methods below to prevent the page from jumping on mobile when the height of the wrapper changes
	 * on step change. It adds the current height of the wrapper to the wrapper and removes it after the new
	 * Step is mounted.
	 */
	public addHeightOnWrapper() {
		const wrapper = this.$refs.stepsWrapper as HTMLElement;
		if (wrapper) {
			wrapper.style.height = `${wrapper.offsetHeight}px`;
		}
	}

	public removeHeightOnWrapper() {
		const wrapper = this.$refs.stepsWrapper as HTMLElement;
		if (wrapper) {
			wrapper.style.height = '';
		}
	}

	protected get stepBackgroundColor(): string | null {
		const activeBackgroundColor = this.steps[this.activeStep].primaryBackgroundColor;
		const globalBackgroundColor = this.primaryBackgroundColor;

		/*
		 * it is only possible to override the color of the active step if there is a global fallback color defined
		 * individual colored steps are not supported if any of the steps is white
		 * */
		if (activeBackgroundColor) return activeBackgroundColor;
		if (globalBackgroundColor) return globalBackgroundColor;
		return null;
	}

	protected async alignModuleToTop(): Promise<void> {
		const LayoutUtil = (await import('@frontend/utils/LayoutUtil')).default;

		LayoutUtil.disableNavigationAndExecuteCallback((): void => {
			const scrollPosition = this.$el.getBoundingClientRect().top + window.pageYOffset;
			window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
		});
	}

	protected onFormSubmitSuccess(): void {
		if (!this.raffleId) return;
		// eslint-disable-next-line @typescript-eslint/camelcase
		pushToDataLayer({ event: 'raffle-success', raffle_name: this.trackingId ? this.trackingId : this.raffleId });
		this.gotoStep('confirmation');
	}
}
